function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useController } from 'react-hook-form';
import { RhfFieldError, rhfMapperReq } from "../../../rhf";
import { InputCountrySelect, InputCountryMultiSelect } from "./input-country-select.component";
export const RhfInputCountrySelect = props => {
  const {
    rhf,
    errorMessage,
    input
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController(rhf);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputCountrySelect, _extends({
    onChange: onChange,
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};
export const RhfInputCountryMultiSelect = props => {
  const {
    rhf,
    errorMessage,
    input
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController(rhfMapperReq(rhf, v => v.length > 0));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputCountryMultiSelect, _extends({
    onChange: onChange,
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};